import { Box } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React from "react";
import DefaultNotification from "../components/socketNotification/DefaultNotification";
import { NotificationFullData } from "./UserNotification";

interface SocketNotificationProps {
  notification: NotificationFullData;
  closePopover: () => void;
}

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    textAlign: "left",
    justifyContent: "space-between",
    border: "1px solid #E5E7EB",
    borderRadius: "10px",
    background: "#F9FAFB",
    width: "100%",
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
  },
  button: {
    background: "var(--button-gradient)",
    color: "var(--neutralWhite)",
    textTransform: "none",
    font: "var(--semibold-xxs)",
    padding: "6px 18px",
    boxShadow: "none",
    minWidth: "85px",
    borderRadius: "8px !important",
    "&:hover": {
      background: "var(--buton-gradient-hover)",
    },
    mt: 1,
    alignSelf: "flex-end",
  },
} as const;

const renderNotification = (notification: NotificationFullData) => {
  switch (notification?.notification_type) {
    default:
      return <DefaultNotification notification={notification} />;
  }
};

const SocketNotification: React.FC<SocketNotificationProps> = ({
  notification,
  closePopover,
}) => {

  const handleClick = () => {
    try {
      closePopover();
    } catch (error) {
      console.error("Navigation error:", error);
      enqueueSnackbar("Failed to navigate to the requested page.", {
        variant: "error",
      });
    }
  };

  return (
    <Box onClick={handleClick} sx={styles.wrapper}>
      {renderNotification(notification)}
    </Box>
  );
};

export default SocketNotification;
